import { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import axios from 'axios';

export const usePushNotifications = () => {
  useEffect(() => {
    if (Capacitor.getPlatform() !== 'web') {
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          PushNotifications.register();
        }
      });

      PushNotifications.addListener('registration', token => {
        console.log('Device token:', token.value);
        axios.post(`${process.env.REACT_APP_API_URL}/register-token`,
          { token: token.value },
          { headers: {
            'x-api-key': process.env.REACT_APP_SECRET_API_KEY },
          }
        );
      });

      PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push received:', notification);
      });
    }
  }, []);
};